import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-auth',
  template: `
    <main class="auth-page" [ngStyle]="currentStyles">
      <div class="auth-page__actions">
        <app-install-cta [compact]="true"></app-install-cta>
        <app-language-dropdown-button
          class="auth-page__language"
          [classList]="'auth-page__language-button'"
        ></app-language-dropdown-button>
      </div>
      <div class="auth-page__content">
        <div class="auth-page__panel">
          <div class="auth-box border-round-md">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </main>`,
  styleUrls: ['./auth.component.scss']
})
export class AuthComponent implements OnInit {
  get currentStyles() {
    return this.route.snapshot.data['background'];
  }
  constructor(
    private readonly route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
  }

}
